import React, { useMemo, memo } from 'react';
import * as Styled from './styled';
import * as GStyled from '../../../styles/components';
import {
  ReportIncludedFieldFilter,
  ReportIncludedFieldFilterOperator,
  ReportField,
  StandardReport,
  ReportFieldType,
} from '../../../models';
import {
  LOGICAL_RULE_SELECT_OPTIONS,
  COMPARISON_RULE_SELECT_OPTIONS,
} from '../../../constants';
import ReportMustHaveFilterValue from './ReportMustHaveFilterValue';
import { groupReportSnapshotMusthaveFieldFilters } from '../../helpers/groupReportSnapshotMusthaveFieldFilters';

interface ReportMustHaveFilterListProps {
  reportField: ReportField;
  clientId: number;
  reportMustHaveFieldFilters?: ReportIncludedFieldFilter[];
  standardReport?: StandardReport;
}

function ReportMustHaveFilterList({
  reportField,
  clientId,
  reportMustHaveFieldFilters,
  standardReport,
}: ReportMustHaveFilterListProps): JSX.Element {
  const renderedFilters = useMemo(() => {
    if (!reportMustHaveFieldFilters || !reportMustHaveFieldFilters.length) {
      return (
        <>
          <div />
          <GStyled.Text>is</GStyled.Text>
          <GStyled.Text>any</GStyled.Text>
        </>
      );
    }

    const displayedFieldFilters =
      reportField.fieldType === ReportFieldType.DropDown
        ? groupReportSnapshotMusthaveFieldFilters(reportMustHaveFieldFilters)
        : reportMustHaveFieldFilters;

    return displayedFieldFilters.map((fieldFilter, index) => {
      const isFirstItem = index === 0;
      const concatOperator = fieldFilter.concatOperator
        ? LOGICAL_RULE_SELECT_OPTIONS[fieldFilter.concatOperator].label
        : '';
      const comparision = COMPARISON_RULE_SELECT_OPTIONS[reportField.fieldType];
      const operator = comparision
        ? comparision[fieldFilter.operator || '='].label
        : '';
      const hasSecondColumn =
        fieldFilter.operator === ReportIncludedFieldFilterOperator.between;
      return (
        <React.Fragment key={index}>
          {!isFirstItem && concatOperator ? (
            <GStyled.Text>{concatOperator}</GStyled.Text>
          ) : (
            <div />
          )}
          <GStyled.Text>{operator.toLowerCase()}</GStyled.Text>
          <Styled.ReportMustHaveFilterValue hasSecondColumn={hasSecondColumn}>
            <ReportMustHaveFilterValue
              clientId={clientId}
              reportField={reportField}
              fieldValue={fieldFilter.fieldValue1}
              standardReportId={
                standardReport ? standardReport.reportId : undefined
              }
            />
            {hasSecondColumn && (
              <>
                <GStyled.Text as="div">and</GStyled.Text>
                <ReportMustHaveFilterValue
                  clientId={clientId}
                  reportField={reportField}
                  fieldValue={fieldFilter.fieldValue2}
                  standardReportId={
                    standardReport ? standardReport.reportId : undefined
                  }
                />
              </>
            )}
          </Styled.ReportMustHaveFilterValue>
        </React.Fragment>
      );
    });
  }, [clientId, reportField, reportMustHaveFieldFilters, standardReport]);

  return (
    <Styled.ReportMustHaveFilterList>
      {renderedFilters}
    </Styled.ReportMustHaveFilterList>
  );
}

export default memo(ReportMustHaveFilterList);
